import React, {useEffect} from "react";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams} from "react-router-dom";
import {fetchAllExpenseProducts, resetCreateStatus, resetUpdateStatus} from "../../store/expense-product-slice";
import ActionDropdown from "../../components/actions/ActionDropdown";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/expenseProductModel";
import {capitalize} from "../../components/Utility";

const ExpenseProductView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const params = useParams();
    const expenseType = params.expenseType;

    const {
        items,
        status
    } = useSelector(state => state.menu.transactionType);

    const {
        items: expenseProducts,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        error
    } = useSelector((state => state.expenseProduct))

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;


    useEffect(() => {
        if (status === "success" && items.length > 0 && expenseType) {
            const match = items.find(
                (item) => item.name.toLowerCase() === expenseType.toLowerCase()
            );

            if (match?._id) {
                dispatch(fetchAllExpenseProducts({
                    ...userRole,
                    expenseTypeId: match._id,
                    page: initialPage,
                    limit: initialLimit
                }));
            }
        }
    }, [dispatch, userRole, initialPage, initialLimit,items, expenseType, status]);

    useEffect(() => {
        if (updateStatus === "success") dispatch(resetUpdateStatus());
        if (createStatus === "success") dispatch(resetCreateStatus());
    }, [dispatch, updateStatus, createStatus]);

    const tableColumns = getTableColumns({ActionDropdown});
    const tableData = getTableData({items: expenseProducts});

    return (
        <>
            <SubHeader title={`All ${capitalize(params.expenseType)} Products`}>
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    );
}
export default ExpenseProductView;
